import { rem } from '@koaly/mixins';

const fontStylesTokens = {
    heading: {
        appearance: {
            default: {
                variant: {
                    default: {
                        color: '@self.tokens.textPrimaryColor',
                        fontFamily: '@self.tokens.headingFontFamily',
                    },
                    secondary: {
                        color: '@self.tokens.textSecondaryColor',
                    },
                    grey: {
                        color: '@self.tokens.textGreyColor',
                    },
                },
                size: {
                    default: {
                        letterSpacing: '-0.01em',
                        fontWeight: 'bold',
                    },
                    h1: {
                        fontSize: rem(42),
                        lineHeight: rem(48),
                        mobileFontSize: rem(28),
                        mobileLineHeight: rem(32),
                    },
                    h2: {
                        fontSize: rem(32),
                        lineHeight: rem(36),
                        mobileFontSize: rem(24),
                        mobileLineHeight: rem(28),
                    },
                    h3: {
                        fontSize: rem(24),
                        lineHeight: rem(28),
                        mobileFontSize: rem(20),
                        mobileLineHeight: rem(32),
                    },
                    h4: {
                        fontSize: rem(20),
                        lineHeight: rem(24),
                        mobileFontSize: rem(18),
                        mobileLineHeight: rem(22),
                    },
                    h5: {
                        fontSize: rem(16),
                        lineHeight: rem(18),
                        mobileFontSize: rem(16),
                        mobileLineHeight: rem(18),
                    },
                    mega: {
                        fontSize: rem(60),
                        lineHeight: rem(68),
                        mobileFontSize: rem(36),
                        mobileLineHeight: rem(42),
                    },
                },
            },
        },
    },
    paragraph: {
        appearance: {
            bold: {
                variant: {
                    default: {
                        fontWeight: 'bold',
                    },
                },
            },
            default: {
                variant: {
                    default: {
                        color: '@self.tokens.textPrimaryColor',
                        fontFamily: '@self.tokens.fontFamily',
                        fontStyle: 'normal',
                        fontWeight: 'normal',
                    },
                    secondary: {
                        color: '@self.tokens.textSecondaryColor',
                    },
                    grey: {
                        color: '@self.tokens.textGreyColor',
                    },
                },
                size: {
                    default: {
                        letterSpacing: '-0.02em',
                    },
                    small: {
                        fontSize: rem(12),
                        lineHeight: rem(16),
                    },
                    medium: {
                        fontSize: rem(16),
                        lineHeight: rem(22),
                    },
                },
            },
        },
    },
    label: {
        appearance: {
            default: {
                variant: {
                    default: {
                        color: '@self.tokens.textPrimaryColor',
                        fontFamily: '@self.tokens.fontFamily',
                        fontWeight: 'normal',
                    },
                    secondary: {
                        color: '@self.tokens.textSecondaryColor',
                    },
                    grey: {
                        color: '@self.tokens.textGreyColor',
                    },
                },
                size: {
                    default: {
                        letterSpacing: '-0.02em',
                    },
                    large: {
                        fontSize: rem(20),
                        lineHeight: rem(24),
                    },
                    medium: {
                        fontSize: rem(16),
                        lineHeight: rem(20),
                    },
                    small: {
                        fontSize: rem(12),
                        lineHeight: rem(16),
                    },
                },
            },
            bold: {
                variant: {
                    default: {
                        fontFamily: '@self.tokens.fontFamily',
                        fontWeight: 'bold',
                    },
                },
            },
        },
    },
    link: {
        appearance: {
            default: {
                variant: {
                    default: {
                        color: '@self.tokens.linkPrimaryColor',
                        colorHover: '@self.tokens.linkPrimaryColorHover',
                        colorActive: '@self.tokens.linkPrimaryColorActive',
                        fontFamily: '@self.tokens.fontFamily',
                        fontWeight: 'normal',
                        textDecoration: 'underline',
                    },
                    secondary: {
                        color: '@self.tokens.linkSecondaryColor',
                        colorHover: '@self.tokens.linkSecondaryColorHover',
                        colorActive: '@self.tokens.linkSecondaryColorActive',
                    },
                    grey: {
                        color: '@self.tokens.linkGreyColor',
                        colorHover: '@self.tokens.linkGreyColorHover',
                        colorActive: '@self.tokens.linkGreyColorActive',
                    },
                },
                size: {
                    default: {
                        letterSpacing: '-0.02em',
                    },
                    large: {
                        fontSize: rem(20),
                        lineHeight: rem(24),
                    },
                    medium: {
                        fontSize: rem(16),
                        lineHeight: rem(20),
                    },
                    small: {
                        fontSize: rem(12),
                        lineHeight: rem(16),
                    },
                },
            },
            bold: {
                variant: {
                    default: {
                        fontFamily: '@self.tokens.fontFamily',
                        fontWeight: 'bold',
                    },
                },
            },
        },
    },
    caption: {
        appearance: {
            default: {
                variant: {
                    default: {
                        fontFamily: '@self.tokens.fontFamily',
                        fontWeight: 'normal',
                        fontStyle: 'italic',
                        color: '@self.tokens.textPrimaryColor',
                    },
                    secondary: {
                        color: '@self.tokens.textSecondaryColor',
                    },
                    grey: {
                        color: '@self.tokens.textGreyColor',
                    },
                },
                size: {
                    default: {
                        letterSpacing: '-0.02em',
                        fontSize: rem(12),
                        lineHeight: rem(16),
                    },
                },
            },
        },
    },
};

export { fontStylesTokens };
//# sourceMappingURL=fontStyles.js.map
